import React, { FC } from 'react';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useController } from 'react-hook-form';
import classNames from 'classnames';

import Icon from '@buyside/components/presentation/Icon/icon';

import DownArrowIcon from '@buyside/svgs/down_arrow.svg';
import UpArrowIcon from '@buyside/svgs/up_arrow.svg';

import fieldStyles from '@buyside/components/presentation/Fields/fieldStyles.scss';
import styles from '../positionsStyles.scss';

const DirectionField: FC<{
  disabled: boolean;
  index: number;
}> = ({ disabled, index }) => {
  const {
    field: { name, onChange, ref, value },
    fieldState: { error },
    formState: { isSubmitting }
  } = useController({ name: `positions.${index}.direction` });

  const isDisabled = disabled || isSubmitting;

  return (
    <div className={classNames(fieldStyles.field, fieldStyles.medium)}>
      <label data-title>Direction</label>
      <div className={styles.directionButtons} ref={ref} tabIndex={-1}>
        <button
          id={`${name}-long`}
          data-selected={value === 'long'}
          disabled={isDisabled}
          onClick={() => onChange('long')}
          type="button"
        >
          <Icon type={UpArrowIcon} />
          long
        </button>
        <button
          id={`${name}-short`}
          data-selected={value === 'short'}
          disabled={isDisabled}
          onClick={() => onChange('short')}
          type="button"
        >
          <Icon type={DownArrowIcon} />
          short
        </button>
      </div>
      {error && !disabled ? (
        <label data-error>
          <FontAwesomeIcon icon={faExclamationCircle} />
          {error.message}
        </label>
      ) : null}
    </div>
  );
};

export default DirectionField;
